import {Injectable} from '@angular/core';
import {GrievanceState} from './_modals/grievance.modal';
import {HttpService} from '../../common/_services/http.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class MainService {


    constructor(private httpSerice: HttpService) {
    }

    getAllGrievanceState() {
        return this.httpSerice.get<any>('casemanager/grievance_state/');
    }

    patchCall(caller: string, receiver: string, schedule_id: string) {
        let params = new HttpParams().set('handler', caller).set('beneficiary', receiver).set('ai_id', schedule_id);
        return this.httpSerice.post(
            'helpline/call/', params
        );
    }
}
